import useDataLoader from '~/hooks/shared/useDataLoader';
import {get_desks} from '~/api/zero-api';


export default function useDesksLoader() {
    return useDataLoader(get_desks);
}